type Params = Record<string, string | number | (string | number)[] | undefined>;

const partialMatchesList = [
  'borrowerFirstName',
  'borrowerLastName',
  'addressStreetName',
  'addressMunicipality'
];

export const buildSearchFilterApiQuery = (params: Params): string => {
  const queryParts: string[] = [];

  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === '') continue;

    if (Array.isArray(value) && value.length > 0) {
      queryParts.push(`filterBy=${key} -in ${value.join(',')}`);
    } else if (!Array.isArray(value)) {
      if (key === 'requestReceiptDateFrom') {
        queryParts.push(`filterBy=${key} -gte ${value}`);
      } else if (key === 'requestReceiptDateTo') {
        queryParts.push(`filterBy=${key} -lte ${value}`);
      } else if (partialMatchesList.includes(key)) {
        queryParts.push(`filterBy=${key} -lk ${value}`);
      } else if (key === 'masterPoolCmhcAccountNumber') {
        queryParts.push(`filterBy=${key} -in ${value}`);
      } else {
        queryParts.push(`filterBy=${key} -eq ${value}`);
      }
    }
  }

  return queryParts.length > 0 ? `&${queryParts.join('&')}` : '';
};
